export const darkThemeStyles = `
  :root {
    --bg-primary: #ffffff; /* White background */
    --bg-secondary: #E2E8F0; /* Very light gray for table headers */
    --bg-card: #ffffff; /* White cards */
    --bg-hover: #f1f3f5; /* Light gray for hover */
    --text-primary: #212529; /* Dark text - almost black */
    --text-primary-header: #0e0d0d; /* Dark text - almost black */
    --text-secondary: #495057; /* Medium dark gray */
    --text-muted: #6c757d; /* Gray for muted text */
    --border-color: #dee2e6; /* Light gray border */
    --accent-primary: #0d6efd; /* Blue accent */
    --accent-secondary: #198754; /* Green accent */
    --accent-orange: #fd7e14; /* Orange accent */
    --positive: #198754; /* Green for positive */
    --negative: #dc3545; /* Red for negative */
    --shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    --shadow-light: 0 1px 2px rgba(0, 0, 0, 0.05);
  }
`;

export { buttonStyles } from "./Shared/Styles/reportToolbarStyles";

export const tableStyles = {
  primary: {
    bg: 'var(--bg-card)',
    color: 'var(--text-primary-header)',
    borderRadius: '8px',
    border: '1px solid var(--border-color)',
    overflow: 'auto',
    width: '100%',
    minWidth: '1000px'
  },
  
  accountHeader: {
    padding: '12px 16px',
    fontWeight: '600',
    color: 'var(--text-primary-header)',
    fontSize: '14px',
    borderBottom: '1px solid var(--border-color)',
    width: '400px',
    minWidth: '400px',
    maxWidth: '400px',
    bg: 'var(--bg-secondary)'
  },
  numberHeader: {
    padding: '12px 16px',
    fontWeight: '600',
    color: 'var(--text-primary-header)',
    fontSize: '14px',
    borderBottom: '1px solid var(--border-color)',
    width: '200px',
    minWidth: '200px',
    maxWidth: '200px',
    bg: 'var(--bg-secondary)'
  },
  percentageHeader: {
    padding: '12px 16px',
    fontWeight: '600',
    color: 'var(--text-primary-header)',
    fontSize: '14px',
    borderBottom: '1px solid var(--border-color)',
    width: '150px',
    minWidth: '150px',
    maxWidth: '150px',
    bg: 'var(--bg-secondary)'
  },
  detailsHeader: {
    padding: '12px 16px',
    fontWeight: '600',
    color: 'var(--text-primary-header)',
    fontSize: '14px',
    borderBottom: '1px solid var(--border-color)',
    width: '250px',
    minWidth: '250px',
    maxWidth: '250px',
    bg: 'var(--bg-secondary)'
  },
  
  accountCell: {
    padding: '10px 16px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '400px',
    minWidth: '400px',
    maxWidth: '400px',
    fontSize: '14px',
    borderBottom: '1px solid var(--border-color)'
  },
  numberCell: {
    padding: '10px 16px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '200px',
    minWidth: '200px',
    maxWidth: '200px',
    fontSize: '14px',
    borderBottom: '1px solid var(--border-color)'
  },
  percentageCell: {
    padding: '10px 16px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '150px',
    minWidth: '150px',
    maxWidth: '150px',
    fontSize: '14px',
    borderBottom: '1px solid var(--border-color)'
  },
  detailsCell: {
    padding: '10px 16px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '250px',
    minWidth: '250px',
    maxWidth: '250px',
    fontSize: '14px',
    borderBottom: '1px solid var(--border-color)'
  },
  
  getRowStyles: (type) => {
    switch (type) {
      case 'group':
        return {
          bg: 'var(--bg-secondary)', 
          fontWeight: '600',
          fontSize: '14px',
          color: 'var(--text-primary-header)'
        };
      case 'subgroup':
        return {
          bg: 'var(--bg-card)', 
          fontWeight: '500',
          fontSize: '14px',
          color: 'var(--text-primary)'
        };
      case 'subtotal':
        return {
          bg: 'var(--bg-secondary)', 
          fontWeight: '600',
          color: 'var(--text-primary-header)',
          borderTop: '2px solid var(--border-color)'
        };
      case 'grouptotal':
        return {
          bg: 'var(--bg-secondary)', 
          fontWeight: '600',
          fontSize: '14px',
          color: 'var(--text-primary-header)',
          borderTop: '2px solid var(--border-color)'
        };
      default:
        return {
          bg: 'transparent',
          color: 'var(--text-primary)',
          fontSize: '14px',
          _hover: { bg: 'var(--bg-hover)' }
        };
    }
  },
  getPaddingLeft: (level) => {
    switch (level) {
      case 0: return '16px';
      case 1: return '32px';
      case 2: return '48px';
      default: return `${16 + (level * 16)}px`;
    }
  }
};

export const cardStyles = {
  primary: {
    bg: 'var(--bg-card)',
    color: 'var(--text-primary)',
    borderRadius: '8px',
    border: '1px solid var(--border-color)',
    boxShadow: 'var(--shadow)'
  }
};

